import { AlchemyProvider } from '@m/alchemy-ui/AlchemyProvider';
import { NAMESPACE, theme } from '@m/alchemy-ui/theme';

export const AlchemyWrapper = ({ children }) => {
  return (
    <AlchemyProvider theme={theme} namespace={NAMESPACE}>
      <div className={NAMESPACE}>{children}</div>
    </AlchemyProvider>
  );
};
